// extracted by mini-css-extract-plugin
export default {"container":"CardControls_container__92i1I","icon":"CardControls_icon__udglq"};